"use client"
import { DesktopBlogNav } from "packages/acquisition/pages/blog/components/Shared/BlogNav/Desktop"
import { MobileBlogNav } from "packages/acquisition/pages/blog/components/Shared/BlogNav/Mobile"
import { BlogPageHeader } from "../../components/Shared/BlogPageHeader"
import { MainPost } from "packages/acquisition/pages/blog/components/Shared/MainPost"
import { PostsGrid } from "packages/acquisition/pages/blog/components/Shared/PostsGrid"
import {
  categoryPostsPerPage,
  blogSlug,
} from "components/Blog/utils/Blog.utils"
import React from "react"
import type {
  ReducedBlogAdmin,
  ReducedBlogV2ArticleType,
} from "types/blog-v2-types"
import { createMarkup } from "utils/createMarkup"
import { BlogPagination } from "../../components/Shared/BlogPagination"

import { container, content } from "./Feed.css"

type Props = {
  posts: ReducedBlogV2ArticleType[]
  total: number
  pageNum: number
  blogDetails: ReducedBlogAdmin
  locale: "en-GB" | "en-US"
}

export const Feed: React.FC<Props> = ({
  posts,
  blogDetails,
  total,
  pageNum,
  locale,
}) => {
  const { title, blogIntro, navItems } = blogDetails
  return (
    <div className={container}>
      <MobileBlogNav
        navItems={navItems}
        currentPage={blogSlug}
        locale={locale}
        blogPage
      />
      <BlogPageHeader title={title} />
      <div
        className={content}
        dangerouslySetInnerHTML={createMarkup(blogIntro)}
      />
      <DesktopBlogNav
        navItems={navItems}
        currentPage={blogSlug}
        locale={locale}
      />
      {posts && posts.length > 2 && pageNum === 1 && (
        <MainPost post={posts[0]} tagDetails={posts[0].tags[0]} />
      )}
      {!!posts?.length && (
        <>
          <PostsGrid
            posts={
              pageNum === 1 && posts.length > 2
                ? posts.slice(1, posts.length)
                : posts
            }
          />
          <BlogPagination
            totalItems={total}
            currentPage={pageNum}
            itemsPerPage={categoryPostsPerPage}
            slug={blogSlug}
            locale={locale}
          />
        </>
      )}
    </div>
  )
}
